<!--
Author: TangChen
Date: 2018-09-06
Desc: 设置页面底部，为公共组件
 -->
<template>
    <div class="comp-footer comp">
        <div class="container">
            <div class="links">
                <a v-for="(link,index) in links" :key="link.n" :href="link.u" :title="link.n" :class="{last:index===links.length-1}">{{ link.n }}</a>
            </div>
            <div class="footer_nav">
                <span v-for="(item,index) in links_rule" :key="index">
                    <span v-on:click="showAgreement(item)">{{item.value}}</span>
                    <span> | </span>
                </span>
            </div>
            <div class="text">
                <div>
                    <span>{{ address }}</span>&emsp;&emsp;
                    <span v-if="$cache.getCompanyInfo().publishnumber&&$cache.getCompanyInfo().publishnumber.trim()">{{ recordnum }}</span>&emsp;&emsp;
                    <span v-if="$cache.getCompanyInfo().copyrightinfo&&$cache.getCompanyInfo().copyrightinfo.trim()">
                        {{ copyright }}
                    </span>
                </div>
                <div>
                    <span v-if="$cache.getCompanyInfo().servicephone&&$cache.getCompanyInfo().servicephone.trim()">{{ servicephone }}</span>
                    <!-- &emsp;&emsp;<span v-if="$cache.getCompanyInfo().companyphone&&$cache.getCompanyInfo().companyphone.trim()">{{ companyphone }}</span>
                    &emsp;&emsp;<span v-if="$cache.getCompanyInfo().faxnumber&&$cache.getCompanyInfo().faxnumber.trim()"> {{ fax }} </span> -->
                    &emsp;&emsp;<span v-if="$cache.getCompanyInfo().companypostcode&&$cache.getCompanyInfo().companypostcode.trim()"> {{ postcode }} </span>
                    &emsp;&emsp;<span v-if="$cache.getCompanyInfo().companyemail&&$cache.getCompanyInfo().companyemail.trim()"> {{ email }} </span>
                </div>
            </div>
        </div>
        <agreement v-model="isShowAgreement" :agrCon="agreementContent" :title="agreementTitle" v-on:all-read="isShowAgreement=false" :style="widht"></agreement>
    </div>
</template>

<script>
import agreement from "@/components/form/agreement2.vue";
export default {
    name: "FooterCon",
    components: {
        agreement
    },
    data () {
        return {
            links: [],
            copyright: "",
            recordnum: "",
            companyphone: "",
            servicephone: "",
            address: "",
            postcode: "",
            fax: "",
            email: "",
            links_rule:[
                {"id":"agreement_gszz","value":"公司资质"},
                {"id":"agreement_fxjs","value":"风险揭示"},
                {"id":"agreement_equity","value":"投资者权益须知"},
                {"id":"agreement_aqzy","value":"安全指引"},
                {"id":"agreement_mztk","value":"免责条款"},
                {"id":"agreement_jjjczs","value":"基金基础知识"},
                {"id":"agreement_yjclts","value":"应急处理提示"},
            ],
            isShowAgreement: false,
            agreementContent: "",
            agreementTitle:"",
            widht:""
        };
    },
    mounted () {
        const companyInfo = this.$cache.getCompanyInfo();
        if (companyInfo && companyInfo.companyaddress) {
            this.links = JSON.parse(companyInfo.companyfootlink || "[]");
            this.copyright = "版权信息: " + companyInfo.copyrightinfo;
            this.recordnum = "备案号: " + companyInfo.publishnumber;
            this.servicephone = "客户服务电话: " + companyInfo.servicephone;
            this.companyphone = "公司办公电话: " + companyInfo.companyphone;
            this.address = "公司地址: " + companyInfo.companyaddress;
            this.fax = "传真: " + companyInfo.faxnumber;
            this.postcode = "邮编: " + companyInfo.companypostcode;
            this.email = "邮箱: " + companyInfo.companyemail;
        }
    },
    methods: {
        showAgreement (item) {
            this.agreementContent = item.id;
            this.agreementTitle =  item.value
            if (!this.$util.isEmpty(this.agreementContent)) {
                this.isShowAgreement = true;
            }

        }
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.comp-footer {
  min-width: 1200px;
  min-height: 80px;
  overflow: hidden;
  text-align: center;
  padding: 8px 0px;
  color: $text-color3;
  .container {
      font-size: 13px;
  }
  .links {
    line-height: 30px;
    a {
      color: $text-color1;
      &:hover {
        color: $color-b;
      }
    }
    a:after {
      content: '|';
      padding: 0 10px;
    }
    a.last:after {
      content: '';
      padding: 0;
    }
  }
    .footer_nav{
        span:last-child{
            span:last-child{
                display: none;
            }
        }
    }
  .text {
    text-align: center;
    position: relative;
    display: inline-block;
    div {
      line-height: 30px;
    }
  }
    .el-dialog{
        height:90%;
        .el-dialog__body {
            text-align: start;
            max-height: 85% ;
            overflow-y: auto;
        }
    }

}
</style>
